module.exports = __webpack_public_path__ + "787b4056a496bb1201befcf9eacc2341.png";